import { Flex, Skeleton, Typography } from '@iheartjane/reefer';
import type { ComponentProps, ReactNode } from 'react';

interface CardSectionProps extends ComponentProps<typeof Flex> {
  children: ReactNode;
  isLoading?: boolean;
  label: string;
}

export const CardSection = ({
  label,
  isLoading,
  children,
  ...boxProps
}: CardSectionProps) => {
  return (
    <Flex flexDirection="column" {...boxProps}>
      {isLoading ? (
        <Skeleton animate>
          <Skeleton.Bone mb={4} height={24} width={230} />
        </Skeleton>
      ) : (
        <Typography variant="caps" color="grays-mid" mb={4}>
          {label}
        </Typography>
      )}

      {children}
    </Flex>
  );
};
